import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import BuiltInModeWrapper from '../../components/BuiltInModeWrapper/BuiltInModeWrapper';
import { AppLoader } from '../AppLoader';

export interface BuiltInShellProps {}

export const BuiltInShell = (props: BuiltInShellProps) => (
    <BuiltInModeWrapper>
        <Suspense fallback={<AppLoader />}>
            <Outlet />
        </Suspense>
    </BuiltInModeWrapper>
);
